import { useEffect } from "react";
import { useLocation, useNavigationType } from "react-router-dom";

/**
 * Component to handle scroll behavior on route changes.
 * - Scrolls to top on PUSH/REPLACE (new navigation).
 * - Leaves scroll position alone on POP (back/forward history).
 */
export default function ScrollToTop() {
    const { pathname } = useLocation();
    const action = useNavigationType();

    useEffect(() => {
        if (action !== "POP") {
            window.scrollTo(0, 0);
        }
    }, [action, pathname]);

    return null;
}
